<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Culture-Foi-Raison" />
            <RevueCulture />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import RevueCulture from './RevueCulture.vue';

export default {
    name: 'PelerinagePage',
    components: {
        NavBar,
        PageTitle,
        RevueCulture,
        FooterComp,
    }
}
</script>